import React, { useId } from 'react';
import '../App.css';

/**
 * Labster two-color ring loader: distinct lime + cyan arcs on a dual-tone track.
 */
const GradientSpinner = ({ size = 56, className = '', label = 'Loading' }) => {
  const rid = useId().replace(/:/g, '');
  const trackGrad = `labster-track-${rid}`;

  return (
    <div
      className={`labster-gradient-spinner ${className}`}
      style={{ width: size, height: size }}
      role="status"
      aria-label={label}
    >
      <svg width={size} height={size} viewBox="0 0 56 56" aria-hidden>
        <defs>
          <linearGradient id={trackGrad} x1="0%" y1="50%" x2="100%" y2="50%">
            <stop offset="0%" stopColor="rgba(181, 255, 51, 0.22)" />
            <stop offset="50%" stopColor="rgba(51, 255, 217, 0.18)" />
            <stop offset="100%" stopColor="rgba(181, 255, 51, 0.14)" />
          </linearGradient>
        </defs>
        {/* Full track: lime ↔ cyan ↔ lime (static) */}
        <circle
          cx="28"
          cy="28"
          r="22"
          fill="none"
          stroke={`url(#${trackGrad})`}
          strokeWidth="4"
        />
        {/* Spinning head: solid lime arc */}
        <g className="labster-gradient-spinner__rotate">
          <circle
            cx="28"
            cy="28"
            r="22"
            fill="none"
            stroke="#B5FF33"
            strokeWidth="4"
            strokeLinecap="round"
            strokeDasharray="20 118"
            transform="rotate(-90 28 28)"
          />
          {/* Second segment: cyan, rotated to sit after lime along the ring */}
          <circle
            cx="28"
            cy="28"
            r="22"
            fill="none"
            stroke="#33FFD9"
            strokeWidth="4"
            strokeLinecap="round"
            strokeDasharray="20 118"
            transform="rotate(-38 28 28)"
          />
        </g>
      </svg>
    </div>
  );
};

export default GradientSpinner;
